export enum Filter {
  All,
  TAP_ContractExpiry,
  Asset,
  System,
}

export const NOTIFICATION_FILTER_DATA = [
  { filterName: Filter.TAP_ContractExpiry, notificationEntityTypeCodes: ['TAP_ContractExpiry'] },
  { filterName: Filter.Asset, notificationEntityTypeCodes: ['Asset'] },
  { filterName: Filter.System, notificationEntityTypeCodes: ['System'] },
];
